<template>
  <!-- Create / Edit -->
  <v-dialog
    v-model="dialog"
    width="600"
    persistent
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-toolbar>
      <v-toolbar-title>{{ $route.meta.nameDrawer }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="closeDialog()"><v-icon>mdi-close</v-icon></v-btn>
    </v-toolbar>

    <v-card>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <!-- ========================================= -->
          <!--             Registration form             -->
          <!-- ========================================= -->
          <v-subheader class="overline pt-4">{{
            $t("registrationForm")
          }}</v-subheader>
          <div class="pa-4 px-6">
            <v-text-field
              :label="$t('routeNameLabel')"
              v-model="form.name"
              :rules="nameRules"
              required
              clearable
              outlined
              dense
              autofocus
            ></v-text-field>
          </div>
          <!-- ========================================= -->
          <!--                Agents                     -->
          <!-- ========================================= -->
          <v-subheader class="overline pt-4">{{
            $t("linkAgents")
          }}</v-subheader>
          <div class="pa-4 px-6">
            <v-select
              v-model="form.agents.select"
              :items="form.agents.items"
              :rules="selectRules"
              item-text="nome"
              item-value="id"
              :label="$t('selectAgents')"
              outlined
              dense
              multiple
              chips
            ></v-select>
          </div>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-alert
        class="ma-4"
        type="warning"
        v-for="item in handleError.items"
        :key="item"
        close-icon
      >
        {{ item }}
      </v-alert>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          :loading="loading"
          v-on:click.prevent="updateRoute"
          type="submit"
          :disabled="!valid"
        >
          {{ $t("btnSave") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { validate } from "@/util/validate";
export default {
  name: "regional-manager-users-collector-update",
  data: () => ({
    // Utils
    valid: false,
    loading: false,
    // Form data:
    form: {
      name: "",
      agents: {
        select: [],
        items: [],
      },
    },
    // Validate Forms:
    nameRules: [validate.required, validate.max],
    requiredRules: [validate.required],
    selectRules: [validate.selectRequired],
    // Handle Error:
    handleError: {
      items: [],
    },
    // Edit
    edit: false,
    id_user: "",
  }),
  async mounted() {
    let agentsAvailable = this.$request.get(
      "regionalManager/routes/agentsAvailable"
    );
    // Request's Simultaneously
    let agents = await agentsAvailable;
    if (agents != undefined) {
      this.form.agents.items = agents.dados;
    }

    // =================================================== //
    // IF - Edit
    // =================================================== //

    if (!this.$route.params.id) {
      return;
    }

    this.edit = true;

    this.id_user = this.$route.params.id;
    let routeData = await this.$request.post(
      "/regionalManager/routes/getRoute",
      { id_user: this.id_user }
    );

    // Handle Agents Selecteds Edit:
    const agentsSelected = routeData.agentsAttachRoute;
    agentsSelected.forEach((element) => {
      this.form.agents.items.push(element);
    });
    this.form.agents.select = agentsSelected;

    const { nome } = routeData.dados;

    this.form.name = nome;
  },
  computed: {
    dialog() {
      return this.$store.state.showDialog;
    },
  },
  watch: {
    dialog(val) {
      !val && this.$router.go(-1);
    },
  },
  methods: {
    //
    // updateRoute: Create or Edit Agent.
    async updateRoute() {
      if (!this.$refs.form.validate()) {
        return;
      }

      // Progress
      this.$store.commit("setFeedbackProgress", true);
      this.loading = true;

      // Body Form
      const formUpdateRoute = {
        nome: this.form.name,
      };

      // Handler routes to formUpdateRoute
      const selected = this.form.agents.select;
      const agentes = {};

      for (let i = 0; i < selected.length; i++) {
        agentes[`agentes[${i}]`] =
          selected[i].id == undefined ? selected[i] : selected[i].id;
      }

      Object.assign(formUpdateRoute, agentes);

      try {
        if (this.edit) {
          Object.assign(formUpdateRoute, { id_rota: this.id_user });
        }

        // Handle Endpoint
        const updateEndpoint = this.edit
          ? "regionalManager/routes/editRoute"
          : "regionalManager/routes/addRoute";

        const result = await this.$request.post(
          updateEndpoint,
          formUpdateRoute
        );
        if (result.length == 0) {
          return;
        }

        this.$store.commit("setFeedbackSnack", {
          msg: result.messages,
          color: "success",
        });

        if (!this.edit) {
          this.$refs.form.reset();
        }

        this.$store.commit("showDialog", false);
        this.$store.commit("setRefresh", true);
      } catch (error) {
        // Multiple error handler:
        if (error.response.status == 406) {
          const items = [];
          var obj = error.response.data.messages;
          for (var [key, value] of Object.entries(obj)) {
            const item = `${key}: ${value}`;
            items.push(item);
          }
          this.handleError.items = items;
        }
      } finally {
        this.loading = false;
      }
    },

    // Close Dialog
    closeDialog() {
      this.$store.commit("showDialog", false);
    },
  },
};
</script>
